import accountEn from "./en/admin/settings/account";
import accountSk from "./sk/admin/settings/account";
import companySK from "./sk/admin/settings/company";
import notification_sf_SK from "./sk/admin/settings/notification_superfaktura";

import itemsSK from "./sk/admin/premium/items";
import mojefirmySK from "./sk/admin/premium/mojefirmy";
import companyusersSK from "./sk/admin/premium/companyusers";
import customcolorSK from "./sk/admin/premium/customcolor";
import reviewsSK from "./sk/admin/premium/reviews";
import statisticsSK from "./sk/admin/premium/statistics";

import feedbackSK from "./sk/admin/others/feedback";
import changelogSK from "./sk/admin/others/changelog";
import klientSK from "./sk/admin/others/klient";
import dashboardSK from "./sk/admin/others/dashboard";
import othersSK from "./sk/admin/others/others";
import notesSK from "./sk/admin/others/notes";

import menuSK from "./sk/admin/layouts/menu";

import other_woutlogSK from "./sk/others_without_login";
import other_woutlogEN from "./en/others_without_login";

import sk from "./sk";
import en from "./en";
import de from "./de";
import cz from "./cz";
export default {
    en: {
        account: { ...accountEn },
        other_woutlog: { ...other_woutlogEN },
        ...en,
    },
    sk: {
        account: { ...accountSk },
        company: { ...companySK },
        notification_sf: { ...notification_sf_SK },
        items: { ...itemsSK },
        mojefirmy: { ...mojefirmySK },
        companyusers: { ...companyusersSK },
        customcolor: { ...customcolorSK },
        reviews: { ...reviewsSK },
        statistics: { ...statisticsSK },
        feedback: { ...feedbackSK },
        changelog: { ...changelogSK },
        klient: { ...klientSK },
        dashboard: { ...dashboardSK },
        menu: { ...menuSK },
        others: { ...othersSK },
        notes: { ...notesSK },
        other_woutlog: { ...other_woutlogSK },
        ...sk,
    },
    de: {
        ...de,
    },
    cz: {
        ...cz,
    },
};
